// The cat sources with a standalone financial-model run (and thus an audit):
// PerilDataSource minus the rms_22_air_50_50 blend, which is priced from two
// runs. The array is the source of truth; the type derives from it.
export const ALL_AUDIT_SOURCES = [
  "rms",
  "air",
  "spatialkat",
  "rms_22",
] as const;

export type FinancialModelAuditSource = (typeof ALL_AUDIT_SOURCES)[number];

// Map a premium-breakdown source (PerilTypePremium.source) to the audit source
// that has its run. The rms_22_air_50_50 blend has no single run, so a peril
// resolved to it has no audit to show.
export const premiumSourceToAuditSource = (
  source: string
): FinancialModelAuditSource | null => {
  switch (source) {
    case "rms":
    case "air":
    case "spatialkat":
    case "rms_22":
      return source;
    default:
      return null;
  }
};
